import "./DropOption.scss";

export class DropOption
{
	constructor()
	{
		this.ConfigureDropOption();
	}

	static GetSelectedValue = (element: HTMLElement): string =>
	{
		const selected = element.querySelector(":checked") as HTMLInputElement;
		return selected.value;
	};

	public ConfigureDropOption = (selector = ".dropdown.dropoption"): void =>
	{
		const dropOptionContainers: NodeListOf<HTMLElement> = document.querySelectorAll(selector);

		dropOptionContainers.forEach(dropOptionContainer =>
		{
			dropOptionContainer.setAttribute("data-value", "");
			this.DropOptionItemBind(dropOptionContainer);
		});
	};

	private DropOptionItemBind = (dropOptionContainer: HTMLElement): void =>
	{
		const dropOptionSelections: NodeListOf<HTMLElement> = dropOptionContainer.querySelectorAll(".dropdown-item");
		let preSelectedIndex: number;
		let preSelectedValue: string;

		dropOptionSelections.forEach((selection, index) =>
		{
			const preSelectedInput: HTMLInputElement = selection.querySelector(":checked");

			["click", "keydown"].forEach(evt =>
			{
				selection.addEventListener(evt, this.DropOptionSelectionHandler);
			});

			if (selection.querySelector(":checked") !== null)
			{
				preSelectedIndex = index;
				preSelectedValue = preSelectedInput.value;
			}
		});


		if (preSelectedIndex !== undefined && preSelectedIndex !== null && preSelectedValue !== "" && preSelectedValue !== undefined && preSelectedValue !== null)
		{
			dropOptionContainer.setAttribute("data-value", preSelectedValue);
			dropOptionSelections[preSelectedIndex].click();
		}

		else if (dropOptionSelections.length === 1)
		{
			dropOptionSelections[0].click();
		}
	};

	private DropOptionSelectionHandler = (e: Event): void =>
	{
		if (e.type === "keydown")
		{
			const keyboardEvent = e as KeyboardEvent;

			if (keyboardEvent.key == "Enter" || keyboardEvent.key === "Space")
			{
				e.preventDefault();
				e.stopPropagation();
			}
		}

		const clickedSelection = e.currentTarget as HTMLElement;
		const clickedRadio = clickedSelection.querySelector("input[type=radio]") as HTMLInputElement;
		const changeEvent = new Event("change");
		const ddl = clickedSelection.closest(".dropoption");
		const form = clickedSelection.closest("form");
		const activeOption = ddl.querySelector(".dropdown-item.active");

		if (activeOption !== null)
		{
			activeOption.classList.remove("active");
		}

		if (ddl !== null)
		{
			ddl.querySelector(".dropdown-toggle > span").innerHTML = clickedSelection.querySelector("span").innerHTML;
			ddl.dispatchEvent(changeEvent);

			if (clickedRadio !== null)
			{
				clickedRadio.checked = true;
				clickedRadio.dispatchEvent(changeEvent);
				clickedSelection.classList.add("active");
				ddl.setAttribute("data-value", clickedRadio.value);
			}

			if (form !== null)
			{
				form.dispatchEvent(changeEvent);
			}
		}
	};
}